import React, {useContext, useState} from 'react';
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import APIWrapperContext from '../../../services/APIWrapperContext';
import {DocumentsService} from '../../../services/openapi/services/DocumentsService';

interface DeleteFileProps {
  curr_dir_id: string;
  type: string;
  name: string;
  onDeleteStart?: () => void;
  onDeleteSuccess?: () => void;
  onDeleteError?: () => void;
}

export const DeleteFile: React.FC<DeleteFileProps> = ({
  curr_dir_id,
  type,
  name,
  onDeleteStart,
  onDeleteSuccess,
  onDeleteError,
}) => {
  const {call_backend_api} = useContext(APIWrapperContext);
  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleClickOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    onDeleteStart?.();
    setDeleting(true);

    call_backend_api(
      DocumentsService.deleteDocumentDocDeleteDocumentHidriveIdDelete(curr_dir_id),
      () => {
        setDeleting(false);
        setOpen(false);
        onDeleteSuccess?.();
      },
      () => {
        setDeleting(false);
        onDeleteError?.();
      },
      undefined,
      true,
      `${type === 'file' ? 'Datei' : 'Ordner'} gelöscht!`,
      `${type === 'file' ? 'Datei' : 'Ordner'} konnte nicht gelöscht werden!`
    );
  };

  return (
    <>
      <Tooltip title='Löschen'>
        <IconButton onClick={handleClickOpen} color='error' aria-label='delete'>
          <DeleteForeverIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={deleting ? undefined : handleClose}
        onClick={(e) => e.stopPropagation()}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'>
        <DialogTitle id='alert-dialog-title'>
          {type === 'file' ? 'Datei löschen' : 'Ordner löschen'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {type === 'file'
              ? `Möchten Sie die Datei "${name}" wirklich löschen?`
              : `Möchten Sie den Ordner "${name}" und alle darin enthaltenen Dateien wirklich löschen?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={deleting}>Abbrechen</Button>
          <Button
            onClick={handleDelete}
            color='error'
            variant='contained'
            autoFocus
            disabled={deleting}
            aria-busy={deleting}
            startIcon={deleting ? <CircularProgress size={16} color='inherit'/> : undefined}
            sx={{minWidth: 128}}>
            {deleting ? 'Wird gelöscht…' : 'Löschen'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
